var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
import { RaftTypeE } from '../types/raft';
export var NewRobotIdE;
(function (NewRobotIdE) {
    NewRobotIdE["NEW"] = "=+__new__+=";
})(NewRobotIdE || (NewRobotIdE = {}));
var ConnectedRaftContext = createContext({
    connectedRafts: [],
    addConnectedRaft: function (connectedRaft) { },
    removeConnectedRaft: function (connectedRaftId) { },
    setSelectedRaft: function (connectedRaftId) { },
});
// Provider component
export var ConnectedRaftContentProvider = function (_a) {
    var children = _a.children;
    var _b = useState([{ id: NewRobotIdE.NEW, isSelected: true, name: "Connect to new robot", type: RaftTypeE.undefined }]), connectedRafts = _b[0], setConnectedRafts = _b[1];
    useEffect(function () {
        if (window.applicationManager) {
            window.applicationManager.connectedRaftContextMethods = {
                addConnectedRaft: function (connectedRaft) {
                    addConnectedRaft(connectedRaft);
                },
                removeConnectedRaft: function (connectedRaftId) {
                    removeConnectedRaft(connectedRaftId);
                },
                setSelectedRaft: function (connectedRaftId) {
                    setSelectedRaft(connectedRaftId);
                },
            };
        }
    }, []);
    useEffect(function () {
        window.applicationManager.connectedRaftsContext = connectedRafts;
    }, [connectedRafts]);
    var addConnectedRaft = function (connectedRaft) {
        // if the new raft is already in the list, do not add it again, just select it
        var existingRaft = connectedRafts.find(function (connectedRaft_) { return connectedRaft_.id === connectedRaft.id; });
        if (existingRaft) {
            setConnectedRafts(function (prev) { return prev.map(function (connectedRaft_) { return (__assign(__assign({}, connectedRaft_), { isSelected: connectedRaft_.id === connectedRaft.id })); }); });
            return;
        }
        // if the newly added raft is selected, deselect the previously selected raft
        if (connectedRaft.isSelected) {
            setConnectedRafts(function (prev) { return prev.map(function (connectedRaft) { return (__assign(__assign({}, connectedRaft), { isSelected: false })); }); });
        }
        setConnectedRafts(function (prev) { return __spreadArray(__spreadArray([], prev, true), [connectedRaft], false); });
    };
    var removeConnectedRaft = function (connectedRaftId) {
        // if the removed raft is selected, select the first raft in the list
        var selectedRaft = connectedRafts.find(function (connectedRaft) { return connectedRaft.isSelected; });
        if ((selectedRaft === null || selectedRaft === void 0 ? void 0 : selectedRaft.id) === connectedRaftId) {
            setConnectedRafts(function (prev) { return prev.map(function (connectedRaft, index) { return (__assign(__assign({}, connectedRaft), { isSelected: index === 0 })); }); });
        }
        setConnectedRafts(function (prev) { return prev.filter(function (connectedRaft) { return connectedRaft.id !== connectedRaftId; }); });
    };
    var setSelectedRaft = function (connectedRaftId) {
        // deselect the previously selected raft
        setConnectedRafts(function (prev) { return prev.map(function (connectedRaft) { return (__assign(__assign({}, connectedRaft), { isSelected: false })); }); });
        setConnectedRafts(function (prev) { return prev.map(function (connectedRaft) { return (__assign(__assign({}, connectedRaft), { isSelected: connectedRaft.id === connectedRaftId })); }); });
    };
    return (_jsx(ConnectedRaftContext.Provider, __assign({ value: { connectedRafts: connectedRafts, addConnectedRaft: addConnectedRaft, removeConnectedRaft: removeConnectedRaft, setSelectedRaft: setSelectedRaft } }, { children: children })));
};
export var useConnectedRafts = function () { return useContext(ConnectedRaftContext); };
